import axios from "axios";
import { API_BASE_URL } from "../../config/env";

/** Public GET — must exist on any deployed API using this repo's users routes. */
export async function checkBackendPublic() {
  const url = `${API_BASE_URL}api/v1/app/config`;
  try {
    const res = await axios.get(url, { timeout: 10000 });
    return { ok: res.status === 200, url, status: res.status };
  } catch (e) {
    const status = axios.isAxiosError(e) ? e.response?.status : undefined;
    return { ok: false, url, status, message: e?.message || "Network error" };
  }
}

/**
 * Admin Panel direct login — email or username + password.
 * Returns { token, user } on success (no OTP step).
 */
export function AdminPanelLogin(payload) {
  return axios.post(`${API_BASE_URL}api/v1/admin/panel/login`, payload, {
    headers: { "Content-Type": "application/json" },
  });
}

// ─── Legacy helpers (kept for backward compatibility) ────────────────────────

/** @deprecated Use AdminPanelLogin instead */
export function AdminLogin(payload) {
  return axios.post(`${API_BASE_URL}api/v1/admin/auth`, payload, {
    headers: { "Content-Type": "application/json" },
  });
}

const VERIFY_PATHS = ["api/v1/verify", "api/v1/auth/verify-otp"];

/** @deprecated No longer used by the admin panel login flow */
export async function OtpVerify(payload) {
  let lastError;
  for (const path of VERIFY_PATHS) {
    try {
      return await axios.post(`${API_BASE_URL}${path}`, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    } catch (e) {
      lastError = e;
      if (axios.isAxiosError(e) && e.response?.status === 404) {
        continue;
      }
      throw e;
    }
  }
  throw lastError;
}
